import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '../shared/services/user.service';
import { filter, take, map } from 'rxjs';

export const authGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);

  if (userService.hasPermission() !== undefined) {
    return userService.hasPermission()
      ? true
      : router.parseUrl('/user-no-permission');
  }

  return userService.hasPermission$.pipe(
    filter((val) => val !== undefined),
    take(1),
    map((hasPermission) =>
      hasPermission ? true : router.parseUrl('/user-no-permission')
    )
  );
};
